import { ValuesOf } from "../../foundation/random";
import { StartEndOptions } from "../start-end/start-end";
import { NatGenButton } from "./button";

/**
 * Button type values.
 *
 * @public
 */
export const ButtonType = {
    submit: "submit",
    reset: "reset",
    button: "button",
} as const;

/**
 * Type for button type values.
 *
 * @public
 */
export type ButtonType = ValuesOf<typeof ButtonType>;

/**
 * Button configuration options
 * @public
 */
export type ButtonOptions = StartEndOptions<NatGenButton>;
